var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider__photos-img-wrapper",style:(`background-image: url('${_vm.getImage(_vm.foto)}')`),on:{"click":function($event){return _vm.$emit('setActiveFoto', _vm.foto)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }